<template>
  <div>
    <div v-if="load_comp">
      <v-container>
        <v-row dense>
          <v-col cols="6" md="6">
            <v-autocomplete
              v-model="sel_tenant"
              :items="tenant_list"
              item-text="name"
              return-object
              label="Select Tenant"
              prepend-icon="mdi-xbox-controller-menu"
            />
          </v-col>
        </v-row>
      </v-container>
      <div v-if="tenant_module_data!=null">
        <v-container>
          <v-row>
            <v-col
              cols="6"
              md="6"
            >Total Modules in edu plus school : {{tenant_module_data.all_modules_size}}</v-col>
            <v-col
              cols="6"
              md="6"
            >Total Active Modules in {{tenant_module_data.tenant_name}}: {{tenant_module_data.all_tenant_modules_size}}</v-col>
          </v-row>
        </v-container>
        <template>
          <v-data-table
            :headers="headers"
            :items="tenant_module_list"
            class="elevation-1"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Modules</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>

                <span style="width: 20px"></span>
                <v-dialog v-model="dialog" max-width="500px">
                  <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">Add Module</v-btn>
                  </template>
                  <v-card>
                    <v-form>
                      <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12" sm="12" md="12">
                              <v-text-field
                                v-model="tenant_module_data.tenant_name"
                                persistent-hint
                                disabled
                                hint="Tenant Name"
                                label="*Tenant"
                              ></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="12" md="12">
                              <v-select
                                :items="all_modules"
                                v-model="to_add_module"
                                item-text="name"
                                item-value="name"
                                persistent-hint
                                label="*Module Name"
                              ></v-select>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        <v-btn color="primary darken-1" @click="save">Save</v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>

            <template v-slot:item.isactive="{ item }">
              <span v-if="item.isactive">
                <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
              </span>
              <span v-else>
                <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
              </span>
            </template>
            <template v-slot:item.action="{ item }">
              <div>
                <v-avatar style size="25" class="edit-avatar">
                  <v-icon class="edit-v-icon mr-2" @click="toggle(item)">edit</v-icon>
                </v-avatar>
              </div>
            </template>
          </v-data-table>
        </template>
      </div>
      <div v-if="tenant_role_type_list!=null">
         <table>
            <tr>
                <th>Role</th>
                <th>Organization</th>
                <th>isActive</th>
            </tr>  
            <tr v-for="item in tenant_role_type_list" :key="item.role_type_id">  
                <td>{{item.role_type}}</td>
                <td>{{item.org}}</td>
                <td>{{item.role_type_isactive}}</td>
            </tr>
         </table>
      </div>
    </div>
    <div v-else>
      <i class="mdi mdi-36px mdi-spin mdi-loading"></i>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data: () => ({
    //1st
    load_comp: false,
    tenant_list: null,
    sel_tenant: null,
    //2nd
    search: "",
    dialog: false,
    tenant_module_data: null,
    all_modules: null,
    tenant_module_list: null,
    to_add_module: null,
    headers: [
      { text: "Module Name", align: "left", value: "name" },
      { text: "Active", align: "left", value: "isactive" },
      { text: "Actions", value: "action", sortable: false }
    ],
    //
    tenant_role_type_list: null
  }),
  watch: {
    sel_tenant() {
      //alert("in sel")
      this.getTenantModules();
    },
    dialog(val) {
      val || this.close();
    }
  },
  computed: {
    formTitle() {
      return "Add Module";
    }
  },
  methods: {
    close() {
      this.dialog = false;
    },
    save() {
      // console.log(this.tenant_module_data.tenant_name)
      // console.log(this.tenant_module_data.tenant_id)
      // console.log(this.to_add_module)
      const formdata = {
        tenant_id: this.tenant_module_data.tenant_id,
        to_add_module: this.to_add_module
      };
      axios
        .post("/admin/addTenantModule", formdata)
        .then(res => {
          if (res.data.msg == "200") {
            this.getTenantModules();
          } else {
            //this.showSnackbar("#b71c1c", "Serror Error. Please try again!!!");
          }
        })
        .catch(error => {
          //this.showSnackbar("#b71c1c", "Something went wrong!!!");
        });
      this.close();
    },
    toggle(item) {
      const formdata = {
        tenant_module_id: item.id,
        tenant_id: this.tenant_module_data.tenant_id
      };
      axios
        .post("/admin/toggleTenantModule", formdata)
        .then(res => {
          if (res.data.msg == "200") {
            if (res.data.status_msg == "OK") {
              item.isactive = res.data.toggle;
              this.tenant_module_data.all_tenant_modules_size =
                res.data.all_tenant_modules_size;
            } else {
              alert(
                "Somthing went wrong. Please verify TenantModule and RoleType"
              );
            }
            ///this.getTenantModules()
            this.tenant_role_type_list = res.data.tenant_role_type_list;
          } else {
            //this.showSnackbar("#b71c1c", "Serror Error. Please try again!!!");
          }
        })
        .catch(error => {
          //this.showSnackbar("#b71c1c", "Something went wrong!!!");
        });
    },
    getTenantModules() {
      axios
        .post("/admin/getTenantModules", this.sel_tenant)
        .then(res => {
          if (res.data.msg == "200") {
            this.tenant_module_data = res.data.tenant_module_data;
            this.all_modules = res.data.all_modules;
            this.tenant_module_list = res.data.tenant_module_list;

            this.tenant_role_type_list = res.data.tenant_role_type_list;
          } else {
            //this.showSnackbar("#b71c1c", "Serror Error. Please try again!!!");
          }
        })
        .catch(error => {
          //this.showSnackbar("#b71c1c", "Something went wrong!!!");
        });
    },
    initcall() {
      axios
        .post("/admin/getTenant")
        .then(res => {
          if (res.data.msg == "200") {
            this.tenant_list = res.data.tenant_list;
            this.load_comp = true;
          } else {
            //this.showSnackbar("#b71c1c", "Serror Error. Please try again!!!");
          }
        })
        .catch(error => {
          //this.showSnackbar("#b71c1c", "Something went wrong!!!");
        });
    }
  },
  mounted() {
    this.initcall();
  }
};
</script>